import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45707755323553:1';
const images = ['https://cdn.magicpatterns.com/uploads/fS2eoz4phNWBJSqbyjXwmU/CARRUSEL_1.png', 'https://cdn.magicpatterns.com/uploads/gg1q1d8fWUnWTqEt1YxSjQ/CARRUSEL_2.png', 'https://cdn.magicpatterns.com/uploads/6SMJnv12RfCbifxQfTXW2Y/CARRUSEL_3.png', 'https://cdn.magicpatterns.com/uploads/dzwMDuCMA5R2Ns6s1ugxq9/CARRUSEL_4.png', 'https://cdn.magicpatterns.com/uploads/eYeiDV6bYihm8DZq893Afy/CARRUSEL_5.png'];
export function ContentCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };
  const nextSlide = () => {
    const isLastSlide = currentIndex === images.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };
  const goToSlide = (slideIndex: number) => {
    setCurrentIndex(slideIndex);
  };
  return <section className="w-full bg-[#FDF8F3] py-16 px-4" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#5C4033] mb-10 text-center" data-id="element-67">
          👀 Mirá una muestra del contenido
        </h2>

        <div className="relative group" data-id="element-68">
          {/* Main Image Container */}
          <div className="w-full max-w-lg mx-auto aspect-[3/4] sm:aspect-[4/3] relative rounded-2xl shadow-lg overflow-hidden border-4 border-[#F5EDE4]" data-id="element-69">
            <a href={CHECKOUT_URL} className="block w-full h-full" data-id="element-70">
              <img src={images[currentIndex]} alt={`Muestra del contenido ${currentIndex + 1}`} className="w-full h-full object-contain bg-white" data-id="element-71" />
            </a>
          </div>

          {/* Left Arrow */}
          <button onClick={prevSlide} className="absolute top-1/2 -translate-y-1/2 -left-3 sm:-left-6 p-2 rounded-full bg-[#8B9E7E] text-white hover:bg-[#6B8068] transition-colors shadow-md z-10" aria-label="Anterior" data-id="element-72">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-73" />
          </button>

          {/* Right Arrow */}
          <button onClick={nextSlide} className="absolute top-1/2 -translate-y-1/2 -right-3 sm:-right-6 p-2 rounded-full bg-[#8B9E7E] text-white hover:bg-[#6B8068] transition-colors shadow-md z-10" aria-label="Siguiente" data-id="element-74">
            <ChevronRightIcon className="w-6 h-6" data-id="element-75" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center py-6 gap-2" data-id="element-76">
          {images.map((_, slideIndex) => <button key={slideIndex} onClick={() => goToSlide(slideIndex)} className={`transition-all duration-300 rounded-full ${currentIndex === slideIndex ? 'w-8 h-2 bg-[#D4956A]' : 'w-2 h-2 bg-[#E8EDE5]'}`} aria-label={`Ir a la imagen ${slideIndex + 1}`} data-id="element-77" />)}
        </div>
      </div>
    </section>;
}